/* Bordado Personalizado JM.
   Nome (peito, ≥1 linha + cor obrigatória) e Logos (posições exclusivas até
   esgotar), com preview ao vivo no jaleco. Cobrança via produtos de serviço.

   VÍNCULO peça↔bordado: a peça e seus add-ons entram no carrinho com o mesmo
   `_jm_codigo` sequencial (JM-1, JM-2...). Esse código existe exclusivamente
   para a bordadeira relacionar a peça aos serviços dentro do pedido.

   Arquivo da logo: sobe pra Cloudinary com UUID global independente do código
   JM. A URL exata retornada fica registrada no pedido e no ERP. Fallback:
   arquivo nativo da Shopify (multipart) e, por último, "enviar depois".

   Tamanho é escolhido DENTRO do modal (sem beco-sem-saída). */
(function () {
  var modal = document.querySelector('[data-jm-bordado]');
  if (!modal || modal.dataset.jmBdInit) return;
  modal.dataset.jmBdInit = '1';

  var cfg;
  try { cfg = JSON.parse(document.querySelector('[data-jm-bd-config]').textContent); } catch (e) { return; }

  // posições com badge no preview do jaleco; posições fora deste mapa (ex.: da
  // touca) continuam selecionáveis, apenas sem badge ilustrativo.
  var POS = { 'Peito direito': 'pd', 'Manga direita': 'md', 'Manga esquerda': 'me' };
  var available = (cfg.posicoes || []).filter(Boolean);
  var sizes = Array.isArray(cfg.sizes) ? cfg.sizes : [];
  var hasSizes = sizes.length > 0;

  function validHex(value) {
    var normalized = String(value || '').trim();
    return /^#[0-9a-f]{6}$/i.test(normalized) ? normalized : null;
  }
  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
    });
  }

  var colors = String(cfg.colors || '').split(/\n+/).map(function (l) {
    var p = l.split('|');
    var hex = p.length >= 2 ? validHex(p[1]) : null;
    return p.length >= 2 && p[0].trim() && hex ? { name: p[0].trim(), hex: hex } : null;
  }).filter(Boolean);

  function money(c) { return 'R$ ' + (c / 100).toFixed(2).replace('.', ','); }

  var TRASH = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16"/><path d="M9.5 7V5.4a1.4 1.4 0 0 1 1.4-1.4h2.2a1.4 1.4 0 0 1 1.4 1.4V7"/><path d="M6.4 7l.8 12.1a1.6 1.6 0 0 0 1.6 1.5h6.4a1.6 1.6 0 0 0 1.6-1.5L18.6 7"/><path d="M10.2 10.6v6.4M13.8 10.6v6.4"/></svg>';

  /* ---------- estado ---------- */
  var state = { nome: false, linha1: '', linha2: '', cor: null, logoOn: false, logos: [], sizeValue: null };

  /* ---------- elementos ---------- */
  var q = function (s) { return modal.querySelector(s); };
  var nomeToggle = q('[data-jm-bd-nome-toggle]');
  var nomeBody = q('[data-jm-bd-nome-body]');
  var logoToggle = q('[data-jm-bd-logo-toggle]');
  var logoBody = q('[data-jm-bd-logo-body]');
  var linha1 = q('[data-jm-bd-linha1]');
  var linha2 = q('[data-jm-bd-linha2]');
  var colorSelect = q('[data-jm-bd-color-select]');
  var colorTrigger = q('[data-jm-bd-color-trigger]');
  var colorSwatch = q('[data-jm-bd-color-swatch]');
  var colorValue = q('[data-jm-bd-color-value]');
  var colorsEl = q('[data-jm-bd-colors]');
  var logosEl = q('[data-jm-bd-logos]');
  var addLogoBtn = q('[data-jm-bd-addlogo]');
  var sizesWrap = q('[data-jm-bd-sizes-wrap]');
  var sizesEl = q('[data-jm-bd-sizes]');
  var totalEl = q('[data-jm-bd-total]');
  var errEl = q('[data-jm-bd-error]');
  var ctaBtn = q('[data-jm-bd-cta]');
  var logoPriceEl = q('[data-jm-bd-logo-price]');

  q('[data-jm-bd-nome-price]').textContent = '+ ' + money(cfg.nome.price);
  q('[data-jm-bd-logo-sub]').textContent = available.join(' · ') || 'Indisponível neste modelo';
  if (!available.length) logoToggle.disabled = true;

  /* ---------- tamanho (dentro do modal) ---------- */
  function pdpSelectedValue() {
    var root = document.querySelector('[data-jm-pdp]');
    var sel = root && root.querySelector('[data-jm-size].is-selected');
    return sel ? sel.getAttribute('data-value') : null;
  }
  function variantForValue(value) {
    for (var i = 0; i < sizes.length; i++) {
      if (sizes[i].value === value && sizes[i].variantId) return String(sizes[i].variantId);
    }
    return null;
  }
  // Produtos com "Cor do Viés" (2ª opção): a variante depende de tamanho + cor. A cor é
  // escolhida no PDP (bolinhas), acima; aqui só resolvemos combinando as duas opções.
  var hasVies = !!document.querySelector('[data-jm-vies]');
  function pdpVariants() {
    try { return JSON.parse(document.querySelector('[data-jm-pdp-variants]').textContent); } catch (e) { return []; }
  }
  function pdpSelectedColor() {
    var b = document.querySelector('[data-jm-vies-btn].is-selected');
    return b ? b.getAttribute('data-value') : null;
  }
  function resolveVariantId() {
    if (!hasVies) return hasSizes ? variantForValue(state.sizeValue) : cfg.defaultVariant;
    var color = pdpSelectedColor();
    if (!color) return null;
    var matches = pdpVariants().filter(function (v) {
      return (!hasSizes || v.option1 === state.sizeValue) && v.option2 === color;
    });
    var chosen = matches.filter(function (v) { return v.available; })[0] || matches[0];
    return chosen ? String(chosen.id) : null;
  }
  // disponibilidade do tamanho no modal: para produtos com viés, depende da cor
  // escolhida no PDP (senão o modal usaria a 1ª cor e mostraria estoque errado).
  function sizeAvailable(value) {
    if (!hasVies) {
      for (var i = 0; i < sizes.length; i++) { if (sizes[i].value === value) return !!sizes[i].available; }
      return false;
    }
    var color = pdpSelectedColor();
    return pdpVariants().some(function (v) { return v.option1 === value && v.option2 === color && v.available; });
  }
  function renderSizes() {
    if (!hasSizes) { if (sizesWrap) sizesWrap.hidden = true; return; }
    sizesWrap.hidden = false;
    sizesEl.innerHTML = sizes.map(function (sz) {
      var sel = state.sizeValue === sz.value ? ' class="is-selected"' : '';
      var dis = sizeAvailable(sz.value) ? '' : ' disabled';
      var checked = state.sizeValue === sz.value ? 'true' : 'false';
      return '<button type="button" role="radio" aria-checked="' + checked + '"' + sel + dis + ' data-size-val="' + String(sz.value).replace(/"/g, '&quot;') + '">' + sz.value + '</button>';
    }).join('');
  }
  if (sizesEl) {
    sizesEl.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-size-val]');
      if (!b || b.disabled) return;
      state.sizeValue = b.getAttribute('data-size-val');
      // espelha no PDP pra manter os dois em sincronia
      var root = document.querySelector('[data-jm-pdp]');
      if (root) {
        root.querySelectorAll('[data-jm-size]').forEach(function (x) {
          x.classList.toggle('is-selected', x.getAttribute('data-value') === state.sizeValue);
        });
      }
      err('');
      renderSizes();
    });
  }

  /* ---------- abrir/fechar ---------- */
  function open() {
    // exige a cor do viés escolhida no PDP (bolinhas) quando o produto tem essa opção
    if (hasVies && !pdpSelectedColor()) {
      var vwrap = document.querySelector('[data-jm-vies-wrap]');
      var pmsg = document.querySelector('[data-jm-pdp-msg]');
      if (pmsg) { pmsg.textContent = 'Escolha a cor do viés para personalizar.'; pmsg.classList.add('is-error'); }
      if (vwrap) vwrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    // herda o tamanho já escolhido no PDP, se houver
    var pre = pdpSelectedValue();
    if (pre && variantForValue(pre)) state.sizeValue = pre;
    renderSizes();
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('jm-bd-lock');
  }
  function close() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('jm-bd-lock');
  }
  document.querySelectorAll('[data-jm-bordado-open]').forEach(function (b) { b.addEventListener('click', open); });
  modal.querySelectorAll('[data-jm-bd-close]').forEach(function (b) { b.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (colorSelect && colorSelect.classList.contains('is-open')) {
      setColorMenu(false);
      colorTrigger.focus();
      return;
    }
    if (modal.classList.contains('is-open')) close();
  });

  /* ---------- nome ---------- */
  nomeToggle.addEventListener('change', function () {
    state.nome = nomeToggle.checked;
    nomeBody.hidden = !state.nome;
    if (!state.nome) {
      state.linha1 = '';
      state.linha2 = '';
      state.cor = null;
      linha1.value = '';
      linha2.value = '';
      renderColorSelection();
      setColorMenu(false);
    }
    err('');
    render();
  });
  linha1.addEventListener('input', function () { state.linha1 = linha1.value; render(); });
  linha2.addEventListener('input', function () { state.linha2 = linha2.value; render(); });

  colorsEl.innerHTML = colors.map(function (c, i) {
    return '<button type="button" role="option" aria-selected="false" data-color="' + i + '">' +
      '<span class="jm-bd__color-option-swatch" style="--jm-bd-thread-color:' + c.hex + '" aria-hidden="true"></span>' +
      '<span class="jm-bd__color-option-name">' + escapeHtml(c.name) + '</span>' +
    '</button>';
  }).join('');

  function setColorMenu(opened) {
    if (!colorSelect || !colorTrigger || !colorsEl) return;
    colorSelect.classList.toggle('is-open', opened);
    colorTrigger.setAttribute('aria-expanded', opened ? 'true' : 'false');
    colorsEl.hidden = !opened;
  }

  function renderColorSelection() {
    if (!colorTrigger || !colorSwatch || !colorValue) return;
    colorTrigger.classList.toggle('is-empty', !state.cor);
    colorSwatch.style.setProperty('--jm-bd-thread-color', state.cor ? state.cor.hex : '#ffffff');
    colorValue.textContent = state.cor ? state.cor.name : 'Selecione uma cor';
    colorsEl.querySelectorAll('button[data-color]').forEach(function (option) {
      var selected = !!state.cor && colors[parseInt(option.dataset.color, 10)] === state.cor;
      option.classList.toggle('is-selected', selected);
      option.setAttribute('aria-selected', selected ? 'true' : 'false');
    });
  }

  colorTrigger.addEventListener('click', function () {
    var opening = !colorSelect.classList.contains('is-open');
    setColorMenu(opening);
    if (opening) {
      var selected = colorsEl.querySelector('.is-selected') || colorsEl.querySelector('button[data-color]');
      if (selected) selected.focus();
    }
  });
  colorsEl.addEventListener('click', function (e) {
    var b = e.target.closest('button[data-color]');
    if (!b) return;
    state.cor = colors[parseInt(b.dataset.color, 10)];
    renderColorSelection();
    setColorMenu(false);
    colorTrigger.focus();
    err('');
    render();
  });
  document.addEventListener('click', function (e) {
    if (colorSelect && !colorSelect.contains(e.target)) setColorMenu(false);
  });
  renderColorSelection();

  /* ---------- logos ---------- */
  logoToggle.addEventListener('change', function () {
    state.logoOn = logoToggle.checked;
    logoBody.hidden = !state.logoOn;
    if (state.logoOn && state.logos.length === 0) state.logos.push({ pos: null, file: null });
    if (!state.logoOn) state.logos = [];
    err('');
    renderLogos();
    render();
  });

  function takenPositions(except) {
    return state.logos.map(function (l, i) { return i === except ? null : l.pos; }).filter(Boolean);
  }

  addLogoBtn.addEventListener('click', function () {
    if (state.logos.length >= available.length) return;
    state.logos.push({ pos: null, file: null });
    renderLogos();
    render();
  });

  function renderLogos() {
    logosEl.innerHTML = state.logos.map(function (l, i) {
      var pills = available.map(function (label) {
        var taken = takenPositions(i).indexOf(label) !== -1;
        var sel = l.pos === label ? ' class="is-selected"' : '';
        return '<button type="button"' + sel + (taken ? ' disabled' : '') + ' data-row="' + i + '" data-pos="' + label + '">' + label + '</button>';
      }).join('');
      return '<div class="jm-bd__logo-row">' +
        '<button type="button" class="jm-bd__logo-remove" data-remove="' + i + '" aria-label="Remover logo">' + TRASH + '</button>' +
        '<div class="jm-bd__field"><span>Posição da logo ' + (i + 1) + '</span><div class="jm-bd__pos">' + pills + '</div></div>' +
        '<div class="jm-bd__field"><span>Arquivo da logo <em>(pode enviar depois)</em></span>' +
          '<div class="jm-bd__file">' +
            '<label class="jm-bd__file-btn">Escolher arquivo<input type="file" accept="image/*,.pdf,.ai,.eps,.cdr" data-file="' + i + '"></label>' +
            '<span class="jm-bd__file-name">' + (l.file ? l.file.name : 'Nenhum arquivo') + '</span>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('');
    addLogoBtn.disabled = state.logos.length >= available.length;
    addLogoBtn.hidden = state.logos.length >= available.length;
  }

  logosEl.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-remove]');
    if (rm) {
      state.logos.splice(parseInt(rm.dataset.remove, 10), 1);
      if (!state.logos.length) {
        state.logoOn = false;
        logoToggle.checked = false;
        logoBody.hidden = true;
      }
      renderLogos();
      render();
      return;
    }
    var pill = e.target.closest('[data-pos]');
    if (pill && !pill.disabled) {
      state.logos[parseInt(pill.dataset.row, 10)].pos = pill.dataset.pos;
      err('');
      renderLogos();
      render();
    }
  });
  logosEl.addEventListener('change', function (e) {
    var input = e.target.closest('input[data-file]');
    if (!input) return;
    state.logos[parseInt(input.dataset.file, 10)].file = input.files[0] || null;
    renderLogos();
    render();
  });

  /* ---------- preview ---------- */
  var FONTS = {
    feminina: { family: 'var(--font-heading--family)', style: 'italic', weight: '500', transform: 'none' },
    masculina: { family: 'var(--font-body--family)', style: 'normal', weight: '700', transform: 'uppercase' },
  };

  function fitText(textEl, baseSize, maxWidth) {
    var size = baseSize;
    textEl.setAttribute('font-size', size);
    try {
      for (var i = 0; i < 3; i++) {
        var w = textEl.getComputedTextLength();
        if (w <= maxWidth || size <= 6) break;
        size = Math.max(6, size * (maxWidth / w));
        textEl.setAttribute('font-size', size.toFixed(1));
      }
    } catch (e) { /* svg fora do DOM visível: mantém base */ }
  }

  function render() {
    var g = q('[data-jm-bd-name]');
    var f = FONTS[cfg.fonte] || FONTS.feminina;
    g.style.display = (state.nome && (state.linha1 || state.linha2)) ? '' : 'none';
    var t1 = q('[data-jm-bd-line1]'), t2 = q('[data-jm-bd-line2]');
    [t1, t2].forEach(function (t) {
      t.style.fontFamily = f.family;
      t.style.fontStyle = f.style;
      t.style.fontWeight = f.weight;
      t.style.textTransform = f.transform;
      t.setAttribute('fill', state.cor ? state.cor.hex : '#c7bfd4');
    });
    t1.textContent = state.linha1;
    t2.textContent = state.linha2;
    fitText(t1, 12, 64);
    fitText(t2, 9, 58);
    var baseY = 190;
    if (state.linha1 && state.linha2) {
      t1.setAttribute('y', baseY - 17);
      t2.setAttribute('y', baseY);
    } else {
      t1.setAttribute('y', baseY);
      t2.setAttribute('y', baseY);
    }

    ['pd', 'md', 'me'].forEach(function (key) {
      var badge = modal.querySelector('[data-jm-bd-badge="' + key + '"]');
      if (!badge) return;
      var row = state.logoOn ? state.logos.filter(function (l) { return l.pos && POS[l.pos] === key; })[0] : null;
      badge.style.display = row ? '' : 'none';
      if (row) {
        var img = badge.querySelector('image');
        var ph = badge.querySelector('[data-jm-bd-ph]');
        if (row.file && row.file.type && row.file.type.indexOf('image/') === 0) {
          img.setAttribute('href', URL.createObjectURL(row.file));
          img.style.display = '';
          if (ph) ph.style.display = 'none';
        } else {
          img.style.display = 'none';
          if (ph) ph.style.display = '';
        }
      }
    });

    var logoCount = state.logoOn ? state.logos.length : 0;
    logoPriceEl.textContent = logoCount > 0
      ? '+ ' + money(logoCount * cfg.logo.price)
      : '+ ' + money(cfg.logo.price) + ' cada';

    var total = cfg.productPrice;
    if (state.nome) total += cfg.nome.price;
    total += logoCount * cfg.logo.price;
    totalEl.textContent = money(total);
  }

  /* ---------- Cloudinary ---------- */
  function cloudinaryReady() {
    return cfg.cloudinary && cfg.cloudinary.cloud && cfg.cloudinary.preset;
  }

  function randomAssetId() {
    // 96 bits em 16 caracteres URL-safe: identidade global, bem menor que UUID.
    var bytes = new Uint8Array(12);
    if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
      window.crypto.getRandomValues(bytes);
      var binary = '';
      Array.prototype.forEach.call(bytes, function (b) { binary += String.fromCharCode(b); });
      return window.btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
    }
    return (Date.now().toString(36) + Math.random().toString(36).slice(2, 12)).slice(0, 16);
  }

  function checkoutBackendOrigin() {
    var raw = String((window.JM_CHECKOUT_CONFIG || {}).backend || '').trim().replace(/\/+$/, '');
    try {
      var url = new URL(raw);
      if (url.protocol === 'https:' || (url.protocol === 'http:' && /^(localhost|127\.0\.0\.1)$/.test(url.hostname))) {
        return url.origin;
      }
    } catch (_) { /* app embed ausente: mantém o upload sem encurtador */ }
    return '';
  }

  function fetchWithTimeout(url, options, timeoutMs) {
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = controller ? window.setTimeout(function () { controller.abort(); }, timeoutMs || 5000) : null;
    var requestOptions = Object.assign({}, options || {}, controller ? { signal: controller.signal } : {});
    return fetch(url, requestOptions).finally(function () {
      if (timer) window.clearTimeout(timer);
    });
  }

  function fallbackStoreFolder() {
    var base = String(cfg.cloudinary.folder || 'jm-bordados').replace(/^\/+|\/+$/g, '');
    var store = String(cfg.shopDomain || 'loja')
      .replace(/\.myshopify\.com$/i, '')
      .replace(/[^a-z0-9_-]+/gi, '-')
      .replace(/^-+|-+$/g, '')
      .toLowerCase() || 'loja';
    return [base, store].join('/');
  }

  var assetConfigPromise = null;
  function cloudinaryStoreFolder() {
    if (assetConfigPromise) return assetConfigPromise;
    var fallback = fallbackStoreFolder();
    var backend = checkoutBackendOrigin();
    if (!backend) return Promise.resolve(fallback);
    var params = new URLSearchParams({
      shop: cfg.shopDomain || '',
      base: cfg.cloudinary.folder || 'jm-bordados',
    });
    assetConfigPromise = fetchWithTimeout(backend + '/api/embroidery/assets/config?' + params.toString(), {
      headers: { Accept: 'application/json' },
    }, 5000)
      .then(function (response) {
        if (!response.ok) throw new Error('asset-config-' + response.status);
        return response.json();
      })
      .then(function (data) {
        return String(data.folder || '').replace(/^\/+|\/+$/g, '') || fallback;
      })
      .catch(function () { return fallback; });
    return assetConfigPromise;
  }

  function datedCloudinaryFolder(storeFolder) {
    var now = new Date();
    return [
      String(storeFolder || fallbackStoreFolder()).replace(/^\/+|\/+$/g, ''),
      String(now.getUTCFullYear()),
      String(now.getUTCMonth() + 1).padStart(2, '0'),
    ].join('/');
  }

  async function registerCloudinaryAsset(asset) {
    var backend = checkoutBackendOrigin();
    if (!backend) return asset.url;
    try {
      var response = await fetchWithTimeout(backend + '/api/embroidery/assets', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          shop: cfg.shopDomain || '',
          baseFolder: cfg.cloudinary.folder || 'jm-bordados',
          url: asset.url,
          assetId: asset.assetId,
          publicId: asset.publicId,
          folder: asset.folder,
        }),
      }, 5000);
      if (!response.ok) throw new Error('asset-register-' + response.status);
      var data = await response.json();
      var shortUrl = new URL(String(data.shortUrl || ''));
      if (!/^\/a\/[A-Za-z0-9_-]{12}$/.test(shortUrl.pathname)) throw new Error('asset-short-url');
      return shortUrl.toString();
    } catch (_) {
      // A URL curta é conveniência para o ERP, nunca dependência do checkout.
      return asset.url;
    }
  }

  async function uploadToCloudinary(file) {
    var c = cfg.cloudinary;
    var assetKey = randomAssetId();
    var folder = datedCloudinaryFolder(await cloudinaryStoreFolder());
    var fd = new FormData();
    fd.append('file', file);
    fd.append('upload_preset', c.preset);
    fd.append('folder', folder);
    fd.append('public_id', assetKey);
    var r = await fetch('https://api.cloudinary.com/v1_1/' + encodeURIComponent(c.cloud) + '/auto/upload', { method: 'POST', body: fd });
    if (!r.ok) throw new Error('cloudinary-' + r.status);
    var j = await r.json();
    // Mesmo com overwrite=false, o Cloudinary pode responder 200 devolvendo
    // um asset antigo. Nunca aceitamos essa resposta como se fosse o upload.
    if (j.existing) throw new Error('cloudinary-existing-asset');
    if (!j.secure_url) throw new Error('cloudinary-nourl');
    var asset = {
      url: j.secure_url,
      assetId: j.asset_id || '',
      publicId: j.public_id || [folder, assetKey].join('/'),
      folder: j.folder || folder,
    };
    asset.shortUrl = await registerCloudinaryAsset(asset);
    return asset;
  }

  /* ---------- adicionar tudo à sacola ---------- */
  function err(msg) { errEl.textContent = msg || ''; }

  // Código de vínculo sequencial por peça personalizada na sacola: JM-1, JM-2...
  // (máximo existente + 1, sobrevive a remoções). Liga peça + seus add-ons.
  async function nextCodigo() {
    try {
      var cart = await fetch('/cart.js').then(function (r) { return r.json(); });
      var max = 0;
      (cart.items || []).forEach(function (it) {
        var c = (it.properties || {})._jm_codigo || '';
        var m = /^JM-(\d+)$/.exec(c);
        if (m) max = Math.max(max, parseInt(m[1], 10));
      });
      return 'JM-' + (max + 1);
    } catch (e) { return 'JM-' + String(Date.now()).slice(-5); }
  }

  ctaBtn.addEventListener('click', async function () {
    err('');
    if (!state.nome && !state.logoOn) return err('Ative o bordado de nome ou o bordado de logo.');
    if (state.nome) {
      if (!state.linha1.trim() && !state.linha2.trim()) return err('Preencha pelo menos uma linha do bordado de nome.');
      if (!state.cor) return err('Escolha a cor da linha do bordado.');
    }
    if (state.logoOn) {
      if (!state.logos.length) return err('Adicione ao menos uma logo ou desative o bordado de logo.');
      for (var i = 0; i < state.logos.length; i++) {
        if (!state.logos[i].pos) return err('Escolha a posição da logo ' + (i + 1) + '.');
      }
    }
    // tamanho: escolhido AQUI dentro. Cor do viés: escolhida no PDP (exigida no open()).
    // resolveVariantId combina tamanho + cor pra achar a variante exata.
    if (hasVies && !pdpSelectedColor()) {
      err('Escolha a cor do viés na página, acima, antes de personalizar.');
      return;
    }
    var variantId = resolveVariantId();
    if (!variantId) {
      err('Escolha o tamanho da peça abaixo.');
      if (sizesWrap) sizesWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    ctaBtn.disabled = true;
    ctaBtn.textContent = 'Adicionando...';

    var codigo = await nextCodigo();

    try {
      // ── PEÇA: resumo enxuto do bordado (código de vínculo + o que vai bordado).
      //    Props internas (_jm_*) são ocultas e removidas na criação do pedido.
      var pieceProps = {
        _jm_codigo: codigo,
        _jm_role: 'peca',
        'Cód. Bord': codigo,
      };
      if (state.logoOn) {
        state.logos.forEach(function (l, i) { pieceProps['Logo ' + (i + 1)] = l.pos; });
      }
      if (state.nome) {
        if (state.linha1.trim()) pieceProps['Linha 1'] = state.linha1.trim();
        if (state.linha2.trim()) pieceProps['Linha 2'] = state.linha2.trim();
        pieceProps['Cor Bordado'] = state.cor.name;
        pieceProps['Posição'] = cfg.posicaoNome || 'Peito esquerdo';
      }
      await addJson({ id: Number(variantId), quantity: 1, properties: pieceProps });

      // ── ADD-ON NOME: ordem operacional fixa para Shopify/ERP.
      if (state.nome) {
        var nomeProps = {
          _jm_codigo: codigo,
          _jm_role: 'addon',
          _jm_tipo: 'nome',
          'Cód. Bord': codigo,
        };
        if (state.linha1.trim()) nomeProps['Linha 1'] = state.linha1.trim();
        if (state.linha2.trim()) nomeProps['Linha 2'] = state.linha2.trim();
        nomeProps['Cor Bordado'] = state.cor.name;
        await addJson({ id: Number(cfg.nome.variant), quantity: 1, properties: nomeProps });
      }

      // ── ADD-ONS LOGO: Cód. Bord · Nº Logo · Posição · URL.
      if (state.logoOn) {
        for (var j = 0; j < state.logos.length; j++) {
          var l = state.logos[j];
          var arquivo = 'Enviar depois (WhatsApp/e-mail)';
          var cloudinaryAsset = null;

          if (l.file && cloudinaryReady()) {
            try {
              cloudinaryAsset = await uploadToCloudinary(l.file);
              arquivo = cloudinaryAsset.shortUrl || cloudinaryAsset.url;
            }
            catch (e) { arquivo = null; } // cai pro nativo abaixo
          } else if (l.file) {
            arquivo = null; // sem cloudinary configurado: tenta nativo
          }

          var logoProps = {
            _jm_codigo: codigo, _jm_role: 'addon', _jm_tipo: 'logo',
            'Cód. Bord': codigo,
            'Nº Logo': String(j + 1),
            'Posição': l.pos,
          };

          if (arquivo) {
            if (cloudinaryAsset) {
              logoProps._jm_cloudinary_asset_id = cloudinaryAsset.assetId;
              logoProps._jm_cloudinary_public_id = cloudinaryAsset.publicId;
              logoProps._jm_cloudinary_folder = cloudinaryAsset.folder;
              logoProps._jm_cloudinary_url = cloudinaryAsset.url;
            }
            logoProps['URL'] = arquivo;
            await addJson({ id: Number(cfg.logo.variant), quantity: 1, properties: logoProps });
          } else {
            // fallback: sobe o arquivo nativo da Shopify (multipart)
            var fd = new FormData();
            fd.append('id', cfg.logo.variant);
            fd.append('quantity', '1');
            Object.keys(logoProps).forEach(function (k) { fd.append('properties[' + k + ']', logoProps[k]); });
            if (l.file) fd.append('properties[URL]', l.file, l.file.name);
            else fd.append('properties[URL]', 'Enviar depois (WhatsApp/e-mail)');
            var r = await fetch('/cart/add.js', { method: 'POST', body: fd });
            if (!r.ok) {
              logoProps['URL'] = 'Enviar por WhatsApp/e-mail';
              await addJson({ id: Number(cfg.logo.variant), quantity: 1, properties: logoProps });
            }
          }
        }
      }

      var cart = await fetch('/cart.js').then(function (r) { return r.json(); });
      var _n = (window.jmVisibleCount ? window.jmVisibleCount(cart) : cart.item_count);
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = _n; });
      try {
        var mod = await import('@shopify/events');
        var Ev = mod.CartLinesUpdateEvent;
        var deferred = Ev.createPromise();
        document.dispatchEvent(new Ev({ action: 'add', context: 'product', lines: [{ merchandiseId: String(variantId), quantity: 1 }], promise: deferred.promise }));
        deferred.resolve({ cart: Ev.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'jm-bordado', itemCount: 1, didError: false } });
      } catch (e) { /* segue */ }

      ctaBtn.textContent = 'Adicionado ✓';
      window.setTimeout(function () {
        close();
        ctaBtn.textContent = 'Adicionar à sacola';
        ctaBtn.disabled = false;
      }, 900);
    } catch (e) {
      ctaBtn.textContent = 'Adicionar à sacola';
      ctaBtn.disabled = false;
      err('Não foi possível adicionar. Tente novamente.');
    }
  });

  function addJson(payload) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (r) {
      if (!r.ok) throw new Error('add-failed');
      return r.json();
    });
  }

  renderSizes();
  render();
})();
